import { createRequest, createUseRequest, createUseRequestMap } from '@/common/createRequest';
import { getKrnDomain } from '@/common/api';
import { request as _request } from '@kibt/krn-utils';
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { reportCatchError } from '@/utils/reportCatchError';
type Merge<F, S> = {
    [P in keyof S]: S[P];
} & {
    [P in keyof F as P extends keyof S ? never : P]: F[P];
};
interface CoverParamsConfig {
    businessName?: string;
    responseType?: string;
    [key: string]: any;
}
interface ExtraConfig {
    headers?: object;
    coverParams?: CoverParamsConfig;
}
export const http = createRequest(
    {
        baseURL: () => '/',
    },
    {
        response: res => res,
        request: req => req,
    }
);
export const useHttp = createUseRequest(http);
export const useHttpMap = createUseRequestMap(useHttp);
export const requestWithCatch = {
    ..._request,
    get: function (url: any, config?: AxiosRequestConfig<any>, extra?: ExtraConfig) {
        return _request.get(url, config, extra).catch(e => {
            // 忽略网络问题引起的错误
            reportCatchError(e);
        }) as Promise<AxiosResponse<any, any>>;
    },
    post: function (url: any, config?: AxiosRequestConfig<any>, extra?: ExtraConfig) {
        return _request.post(url, config, extra).catch(e => {
            // 忽略网络问题引起的错误
            reportCatchError(e);
        }) as Promise<AxiosResponse<any, any>>;
    },
};
